import { render } from "./PayorRow.vue?vue&type=template&id=513136dc&ts=true"
import script from "./PayorRow.ts?vue&type=script&lang=ts&external"
export * from "./PayorRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__